import ziggyRoute from 'ziggy-js';
import { Ziggy } from './ziggy';

let routes = require('./routes.json');

window.route = function() {
    let args = Array.prototype.slice.call(arguments);
    let name = args.shift();
    let origin = '';

    if (window.location.origin) {
        origin = window.location.origin;
    }

    if (routes[name] === undefined) {
        console.error('Unknown route, please execute npm run dev or php artisan route:json', name);
    } else {
        return origin + '/' + routes[name]
            .split('/')
            .map(s => s[0] === '{' ? args.shift() : s)
            .join('/');
    }
};

if (window.location) {
    Ziggy.url = window.location.origin;
}

window.$route = (name, params, absolute) => ziggyRoute(name, params, absolute, Ziggy);